import _ from 'lodash';
import { getData } from 'Source/globalFunction';

/**
 * @returns {ThunkAction}
 */
export function initialize(taskId, settings = {}) {
  return (dispatch, getState) => {
    const state = getState();
    const { loggedUser } = state;
    let requests = [];

    // dispatch({ type: "SET_SCREEN_LOADER", Loading: true });

    requests.push(
      getData(
        `/api/conversation/getConversationList?page=1&linkType=task&linkId=${taskId}`,
        {},
        (c) => {
          if (c.status === 200) {
            const { data } = c;
            dispatch({ type: 'SET_COMMENT_LIST', list: data.result, count: data.count });
          }
        }
      )
    );

    requests.push(
      getData(`/api/timeLog/tasklog?taskId=${taskId}&page=1`, {}, (c) => {
        if (c.status === 200) {
          dispatch({ type: 'SET_TASKTIMELOG_LIST', list: c.data.result, count: c.data.count });
          dispatch({ type: 'SET_TOTAL_HOURS', total: c.data.total_hours });
        }
        return Promise.resolve();
      })
    );

    requests.push(
      getData(`/api/task/detail/${taskId}?starredUser=${loggedUser.data.id}`, {}, (c) => {
        if (c.status === 200 && !c.data.error) {
          dispatch({ type: 'SET_TASK_SELECTED', Selected: c.data });
          dispatch({ type: 'SET_TASK_LOADING', Loading: '' });
        }
        return Promise.resolve();
      })
    );

    if (Object.keys(settings).length) {
      dispatch({
        type: 'TASK_FORM_SET_EVENT_LISTENERS',
        onUpdate: settings.onUpdate,
        onCreate: settings.onCreate,
        onDelete: settings.onDelete,
      });
    }

    return Promise.all(requests)
      .then(() => {
        // dispatch({ type: "SET_SCREEN_LOADER", Loading: false });
      })
      .catch((error) => {
        console.error(error);
      });
  };
}

/**
 * @returns {ThunkAction}
 */
export function setEventListeners(eventListeners) {
  return (dispatch) => {
    dispatch({
      type: 'TASK_FORM_SET_EVENT_LISTENERS',
      onUpdate: eventListeners.onUpdate,
      onCreate: eventListeners.onCreate,
      onDelete: eventListeners.onDelete,
    });

    return Promise.resolve();
  };
}

/**
 * @returns {ThunkAction}
 */
export function showForm(source, settings) {
  return (dispatch) => {
    dispatch({
      type: 'TASK_FORM_SET_SHOW_FORM',
      source: source,
      ...(settings.onCreate && { onCreate: settings.onCreate }),
      ...(settings.customSuccessToastEnabled && { customSuccessToastEnabled: settings.onCreate }),
      ...(settings.onUpdate && { onUpdate: settings.onUpdate }),
      ...(settings.onDelete && { onDelete: settings.onDelete }),
    });

    return Promise.resolve();
  };
}

/**
 * @returns {ThunkAction}
 */
export function setSource(source) {
  return (dispatch) => {
    dispatch({
      type: 'TASK_FORM_SET_SOURCE',
      source: source,
    });

    return Promise.resolve();
  };
}

/**
 * @returns {ThunkAction}
 */
export function setCustomSuccessToastEnabled(customSuccessToastEnabled) {
  return (dispatch) => {
    dispatch({
      type: '~',
      customSuccessToastEnabled: customSuccessToastEnabled,
    });

    return Promise.resolve();
  };
}

/**
 * @returns {ThunkAction}
 */
export function setOnCreate(onCreate) {
  return (dispatch) => {
    dispatch({
      type: 'TASK_FORM_SET_ON_CREATE',
      onCreate: onCreate,
    });

    return Promise.resolve();
  };
}

/**
 * @returns {ThunkAction}
 */
export function setOnUpdate(onUpdate) {
  return (dispatch) => {
    dispatch({
      type: 'TASK_FORM_SET_ON_UPDATE',
      onUpdate: onUpdate,
    });

    return Promise.resolve();
  };
}

/**
 * @returns {ThunkAction}
 */
export function setTask(task) {
  return (dispatch) => {
    dispatch({
      type: 'TASK_FORM_SET_TASK',
      task: task,
    });

    return Promise.resolve();
  };
}

/**
 * @returns {ThunkAction}
 */
export function resetTaskForm() {
  return (dispatch) => {
    dispatch({ type: 'TASK_FORM_RESET' });

    return Promise.resolve();
  };
}

/**
 *
 * @returns {ThunkAction}
 */
export function taskCreated(task, activityLogs = []) {
  return async (dispatch, getState) => {
    const state = getState();
    const { onCreate } = state.taskForm;
    if (onCreate) {
      dispatch(setTask(task[0]));

      await getData(
        `/api/conversation/getConversationList?page=1&linkType=task&linkId=${task[0].id}`,
        {},
        (c) => {
          if (c.status === 200) {
            const { data } = c;
            dispatch({ type: 'SET_COMMENT_LIST', list: data.result, count: data.count });
          }
        }
      );

      onCreate(task, activityLogs);
    }

    return Promise.resolve();
  };
}

/**
 *
 * @returns {ThunkAction}
 */
export function taskChanged(task) {
  return (dispatch, getState) => {
    const state = getState();
    const { onUpdate } = state.taskForm;

    if (onUpdate) {
      dispatch(setTask(task));
      onUpdate(task);
    }

    return Promise.resolve();
  };
}

/**
 *
 * @returns {ThunkAction}
 */
export function taskDeleted({ deletedTaskIds, updatedTasks }) {
  return (dispatch, getState) => {
    const state = getState();
    const { onDelete } = state.taskForm;

    if (onDelete) {
      onDelete({ deletedTaskIds, updatedTasks });
    }

    return Promise.resolve();
  };
}
